export const HireAngularBannerDataEn = {
  mainHeading: "Hire Angular Developers",
  content: "Your trusted partner for expert Angular development, ideal for startups & enterprises looking for scalable, high-performance web applications.",
  btnText: "Consult Our Angular Developers Today",
  HireAngularBannerList: [
    { list: "Freelance Contractors" },
    { list: "Full-time Roles" },
    { list: "Global Talent Pool" },
  ]
};

export const HireAngularServicesDataEn = {
  mainHeading: "Our Angular Developer Expertise",
  sectionDescription: "Our Angular developers excel at building fast, interactive, & scalable web applications, ensuring smooth functionality & outstanding user experiences.",
  buttonText: "Schedule a Call Today",
  servicesData: [
    {
      title: "Angular Consulting",
      description:
        "Get expert guidance to optimize your Angular projects—whether you're launching a new app or enhancing an existing one.",
      icon: "/images/hire-page-icons/hire-angular-icons1.svg",
    },
    {
      title: "Angular Web Development",
      description:
        "We craft dynamic, user-friendly, & responsive web applications that deliver seamless experiences across all devices.",
      icon: "/images/hire-page-icons/hire-angular-icons2.svg",
    },
    {
      title: "Angular API Development",
      description:
        "Our team builds robust APIs that enable smooth communication between platforms, ensuring efficient data exchange.",
      icon: "/images/hire-page-icons/hire-angular-icons3.svg",
    },
    {
      title: "Angular CMS & Portal Development",
      description:
        "Develop scalable, high-performance CMS & custom web portals with easy content management & intuitive interfaces.",
      icon: "/images/hire-page-icons/hire-angular-icons4.svg",
    },
    {
      title: "Migration to Angular",
      description:
        "Seamlessly transition to Angular while preserving your data & enhancing application performance.",
      icon: "/images/hire-page-icons/hire-angular-icons5.svg",
    },
    {
      title: "Integration with Existing Solutions",
      description:
        "Ensure flawless compatibility between Angular applications & your existing tools, services, & platforms.",
      icon: "/images/hire-page-icons/hire-angular-icons6.svg",
    },
    {
      title: "Angular eCommerce Solutions",
      description:
        "Create engaging, feature-rich eCommerce platforms that offer fast performance & smooth user experiences.",
      icon: "/images/hire-page-icons/hire-angular-icons7.svg",
    },
    {
      title: "Angular Support & Maintenance",
      description:
        "Keep your Angular apps optimized, secure, & up-to-date with our proactive support & maintenance services.",
      icon: "/images/hire-page-icons/hire-angular-icons8.svg",
    },
  ]
}

export const HireAngularSolutionsDataEn = {
  mainHeading: "Why Choose Bitsclan to Hire ",
  greenHeading: "Angular Developers?",
  sectionDescription: "We leverage Angular & modern technologies to develop scalable, high-performance applications tailored to your business needs. Whether you're building a web platform or a mobile solution, we ensure smooth performance, efficiency, & a seamless user experience.",
  buttonText: "Hire a developer today",
  solutions: [
    {
      icon: "/images/hire-page-icons/chose-ror-section1.svg",
      title: "Access vetted talent",
      description:
        "Work with skilled Angular developers, carefully vetted for their technical expertise & effective communication skills.",
    },
    {
      icon: "/images/hire-page-icons/chose-ror-section2.svg",
      title: "Find the Right Match Instantly",
      description:
        "Skip the endless resume reviews. With HireAI, quickly discover top Angular developers who match your project requirements.",
    },
    {
      icon: "/images/hire-page-icons/chose-ror-section3.svg",
      title: "Cost-Effective Global Hiring",
      description:
        "Tap into a global talent network while reducing hiring costs—access top professionals at competitive rates.",
      noBorder: true,
    },
    {
      icon: "/images/hire-page-icons/chose-ror-section4.svg",
      title: "Dedicated Human Support",
      description:
        "Get expert guidance at every step. Our recruitment specialists ensure you hire the perfect Angular developer for your team.",
    },
  ]
}

export const techCombinationsEn = {
  mainHeading: "Top Angular Technology Combinations for High-Performance Development",
  sectionDescription: "Harness the power of Angular with the right technology stack to build dynamic, scalable, & efficient web applications. Hire expert Angular developers to ensure exceptional development & seamless user experiences.",
  combinations: [
    {
      title: "Angular + Node.js (JS/TS)",
      description:
        "Angular at the front end & Node.js (JavaScript/TypeScript) at the back end are robust choices for full-stack JavaScript applications.",
      icons: [
        { icon: "angular.svg", altText: "Angular front-end framework" },
        { icon: "nodejs.svg", altText: "Node.js backend runtime" },
      ],
    },
    {
      title: "Angular + Django (Python)",
      description:
        "Angular at the front end & our Django services on the backend can build modern web apps with real-time collaboration & rapid prototyping.",
      icons: [
        { icon: "angular.svg", altText: "Angular front-end framework" },
        { icon: "python.svg", altText: "Python Django backend framework" },
      ],
    },
    {
      title: "Angular + Ruby on Rails (RoR)",
      description:
        "The apps that are API-driven or need rich interfaces are perfect to be built on this combo-Angular (TypeScript) on the front end & RoR on the back end.",
      icons: [
        { icon: "angular.svg", altText: "Angular front-end framework" },
        { icon: "ruby_on_rails.svg", altText: "Ruby on Rails backend framework" },
      ],
    },
    {
      title: "Angular + PHP",
      description:
        "Angular (front-end) & PHP (server-side scripting language) is used in the development of dynamic & interactive web apps.",
      icons: [
        { icon: "angular.svg", altText: "Angular front-end framework" },
        { icon: "php.svg", altText: "PHP server-side scripting language" },
      ],
    },
  ],
}

export const HireAngularStepsEn = {
  mainHeading: "Hire Angular Developers in 4 Simple Steps",
  sectionDescription: "Finding the right Angular developer is quick & seamless with our efficient 4-step process.",
  buttonText: "Let’s Find Your Perfect Developer",
  angularSteps: [
    {
      title: "Choose your Engagement Model",
      description:
        "Pick the model that suits your project: Full-Time, Part-Time, or Hourly—flexible hiring tailored to your needs.",
      icon: "/images/hire-page-setps-icons/icon-1.svg",
    },
    {
      title: "Select Top Angular Developers",
      description:
        "Review pre-vetted Angular experts & shortlist the best candidates for your project.",
      icon: "/images/hire-page-setps-icons/icon-2.svg",
    },
    {
      title: "Conduct Personalized Interviews",
      description:
        "Assess skills, expertise, & problem-solving approach through one-on-one interviews.",
      icon: "/images/hire-page-setps-icons/icon-3.svg",
    },
    {
      title: "Onboard & Get Started",
      description:
        "Once selected, your Angular developer joins your team within 24-48 hours, ready to contribute.",
      icon: "/images/hire-page-setps-icons/icon-4.svg",
    },
  ]
}

export const hireAngularCoverTheStackEn = {
  mainHeading: "Enhance Your Angular Development with a Cutting-Edge Tech Stack",
  sectionDescription: "At Bitsclan, we accelerate your Angular development with a meticulously selected tech stack that ensures high performance & scalability. Our Angular experts leverage the latest technologies to build dynamic, responsive, & custom web applications tailored to your business needs.",
  defaultOpenTab: "Languages",
  tabs: [
    "Languages",
    "Libraries & UI Libraries",
    "Frameworks",
    "Testing",
    "Platforms",
  ],
  tabItems: [
    { tab: "Languages", icon: "/images/icon7.png", name: "HTML5" },
    { tab: "Languages", icon: "/images/icon6.png", name: "CSS3" },
    { tab: "Languages", icon: "/images/icontwo.png", name: "JavaScript" },
    { tab: "Languages", icon: "/images/tech-stack-icons/typescript.svg", name: "TypeScript" },
    { tab: "Languages", icon: "/images/tech-stack-icons/graphql.svg", name: "GraphQL" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/rx-js.svg", name: "Rxjs" },
    { tab: "Libraries & UI Libraries", icon: "/images/iconthree.png", name: "React" },
    { tab: "Libraries & UI Libraries", icon: "/images/tech-stack-icons/jquery.svg", name: "jQuery" },
    { tab: "Libraries & UI Libraries", icon: "/images/iconone.png", name: "Angular CLI" },
    { tab: "Frameworks", icon: "/images/tech-stack-icons/Ionic.svg", name: "Ionic" },
    { tab: "Frameworks", icon: "/images/tech-stack-icons/bootstrap.svg", name: "Bootstrap" },
    { tab: "Frameworks", icon: "/images/database2.png", name: "Nest Js" },
    { tab: "Frameworks", icon: "/images/mobile4.png", name: "Flutter" },
    { tab: "Frameworks", icon: "/images/icon4.png", name: "Vue.js" },
    { tab: "Frameworks", icon: "/images/tech-stack-icons/tailwind.svg", name: "Tailwind" },
    { tab: "Frameworks", icon: "/images/iconone.png", name: "AngularJS" },
    { tab: "Frameworks", icon: "/images/iconone.png", name: "Angular2+" },
    { tab: "Testing", icon: "/images/tech-stack-icons/postman.svg", name: "Postman" },
    { tab: "Testing", icon: "/images/tech-stack-icons/seaborn.svg", name: "Jmeter" },
    { tab: "Testing", icon: "/images/qa6.svg", name: "Selenium" },
    { tab: "Testing", icon: "/images/tech-stack-icons/cypress.svg", name: "Cypress" },
    { tab: "Testing", icon: "/images/tech-stack-icons/browserstack.svg", name: "BrowserStack" },
    { tab: "Testing", icon: "/images/tech-stack-icons/bugzilla.svg", name: "Bugzilla" },
    { tab: "Testing", icon: "/images/tech-stack-icons/soap-icon.svg", name: "SoapUI" },
    { tab: "Testing", icon: "/images/tech-stack-icons/jasmine.svg", name: "Jasmine" },
    { tab: "Testing", icon: "/images/tech-stack-icons/karma.svg", name: "Karma" },
    { tab: "Platforms", icon: "/images/db1.png", name: "Firebase" },
    { tab: "Platforms", icon: "/images/devops3.png", name: "Docker" },
    { tab: "Platforms", icon: "/images/cloud2.png", name: "Azure AWS" },
    { tab: "Platforms", icon: "/images/cloud3.png", name: "AWS" },
  ]
}

export const HireAngularFactsDataEn = {
  mainHeading: "Quick Facts About ",
  greenHeading: "Our Angular Team",
  buttonText: "book an appointment",
  factData: [
    {
      text: "Our team of 10+ Angular developers specializes in building high-performance web applications.",
    },
    {
      text: "With an average of 5+ years of experience, our developers ensure expert-level development & seamless execution.",
    },
    {
      text: "We leverage modern tools & libraries to create fast, scalable, & reliable Angular applications.",
    },
    {
      text: "Our expertise includes dynamic, interactive, & responsive UI development for enhanced user experiences.",
    },
    {
      text: "We build scalable web & mobile applications across industries, including eCommerce & enterprise solutions.",
    },
    {
      text: "Our team excels in API development & third-party integrations, ensuring smooth connectivity between systems.",
    },
  ]
}

export const hireAppContentEn = {
  mainHeading: "Not Sure About Your App Idea? Get a Prototype in Just Weeks!",
  sectionDescription: "Have an app idea but unsure how to proceed? Our expert Ruby on Rails developers can help you bring your vision to life with a fully functional prototype in just 6-8 weeks. Validate your concept, test user engagement, & build a solid foundation for long-term success—without the guesswork."
}

export const HireAngularFaqDataEn = {
  mainHeading: "Frequently Asked Questions",
  sectionDescription: "Discover answers to common questions about Angular.",
  questionAnswer: [
    {
      id: "collapseOne",
      question: "What is Angular web development?",
      answer:
        "Angular web development refers to creating web applications using the Angular framework, which helps developers build dynamic, interactive, & scalable applications.",
    },
    {
      id: "collapseTwo",
      question: "Why should I hire Angular developers from Bitsclan?",
      answer:
        "By hiring Angular developers from Bitsclan, you get access to experts who can create high-performance web apps tailored to your needs, ensuring smooth user experiences & functionality.",
    },
    {
      id: "collapseThree",
      question: "Can you migrate my existing web app to Angular?",
      answer:
        "Yes! Our Angular experts can help you migrate your existing web applications to Angular, ensuring a smooth transition & enhanced performance.",
    },
    {
      id: "fourth",
      question: "What types of apps can be built with Angular?",
      answer:
        "With Angular, we can build all kinds of apps, including eCommerce platforms, enterprise solutions, content management systems (CMS), & more. Angular is great for dynamic & responsive web applications.",
    },
    {
      id: "fifth",
      question: "How does Angular improve my app’s performance?",
      answer:
        "Angular helps build scalable, fast-loading apps. It uses efficient coding practices & tools like two-way data binding & dependency injection to improve app performance & maintainability.",
    },
    {
      id: "sixth",
      question: "How long does it take to develop an Angular web application?",
      answer:
        "The development timeline depends on the complexity of the project. Simple apps can be developed in a few weeks, while larger, more complex applications may take a few months. We work with you to create realistic timelines.",
    },
  ]
}












export var mainBannerImgAngular = {
  backgroundImage: `url(/images/hire-page-images/hire-angular.avif)`,
  factBackgroundImage: `url(/images/hire-page-images/hire-angular.avif)`,
};

export const HireAngularStacksdata = [
  {
    title: "Junior Ruby on Rails Developer",
    description: [
      "2 Years' experience",
      "Fresh perspectives & innovative ideas",
      "Dedicated to explore web development",
    ],
    linkText: "Connect to Hire",
    link: "#",
    borderClass: "border-1",
  },
  {
    title: "Senior Ruby on Rails Developer",
    description: [
      "2+ years' experience",
      "Leadership in complex projects",
      "Proven app deployment success",
    ],
    linkText: "Connect to Hire",
    link: "#",
    borderClass: "border-2",
  },
  {
    title: "Ruby on Rails Tech Lead",
    description: [
      "5+ years' experience",
      "Skilled with Jira, Asana, MS Teams, etc.",
      "Suitable when you Hire Web App Team",
    ],
    linkText: "Connect to Hire",
    link: "#",
    borderClass: "border-3",
  },
];

export const HireAngularBenefitsData = [
  {
    service: "Android CMS Development",
    description:
      "Get an upper hand on your web content, augment efficiency, & develop a shared environment with our Ruby on Rails CMS solutions.",
  },
  {
    service: "Ruby on Rails Migrations",
    description:
      "Our Ruby on Rails engineers strategically migrate legacy content into modern systems in a secured, erAndroid-free, & robust way.",
  },
  {
    service: "Advanced android Programming",
    description:
      "Our experts have extensive experience in using android tech stack for tangible results to reach your business vision.",
  },
  {
    service: "Android Integration & Optimization",
    description:
      "Leverage the full-scale potential of Ruby on Rails integration & optimization functionalities for your app development needs.",
  },
  {
    service: "Customized android Solutions",
    description:
      "Our Ruby on Rails developers delve into ideation, reinvention, & scale development as per your enterprise's unique IT demands.",
  },
  {
    service: "Android eCommerce App",
    description:
      "With using modern android tools & technologies, we have a proven track record of developing scalable & secured eCommerce sites.",
  },
];

export const HireAngularWhoWeServeData = [
  {
    icon: "/images/servie-icon/startups.png",
    title: "Budget savings",
    description:
      "Assembling a local Ruby on Rails team is unavoidably expensive. By approaching Innowise. you bypass many hurdles & avoid redundantexpenses such as training fees. taxes. & software licenses.",
    link: "#",
    borderClass: "border-1",
  },
  {
    icon: "/images/servie-icon/companies.png",
    title: "Software product companies",
    description:
      "When you hire android developers. you avoid the risks of budget overruns & missed deadlines. Innowise provides solid risk management plans & has an array of risk mitigation measures",
    link: "#",
    borderClass: "border-2",
  },
  {
    icon: "/images/servie-icon/industries.png",
    title: "Enterprises from 30+ industries",
    description:
      "Innowise has experts with excellent development backgrounds. so you can rest assured that your project is in good hands. Pyrggyelgprneg",
    link: "#",
    borderClass: "border-3",
  },
];

export const HireAngularPageDeliverData = [
  {
    image: "/images/hire-page-images/card-1.avif",
    title: "Complex SaaS systems",
    description:
      "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc.",
  },
  {
    image: "/images/hire-page-images/card-2.avif", // Assumed path based on provided example
    title: "Complex SaaS systems",
    description:
      "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc.",
  },
  {
    image: "/images/hire-page-images/card-3.avif", // Assumed path based on provided example
    title: "Complex SaaS systems",
    description:
      "Innowise provides its expertise in the area of building complex platforms for businesses to streamline workflows. The main applications we develop include HRM, CRM, ERP, accounting software, etc.",
  },
];

export const HireAngularSlidesData = [
  {
    title: "Experienced android Developers",
    content:
      "Our team consists of senior android developers who have extensive experience in building sophisticated web applications across various industries.",
    backgroundClass: "bg-1",
  },
  {
    title: "Remote & On-Demand",
    content:
      "Need flexibility? Hire remote android developers from Bitsclan for seamless project execution without geographic limitations.",
    backgroundClass: "bg-2",
  },
  {
    title: "Agile Development Approach",
    content:
      "We follow agile methodologies to ensure rapid delivery, transparency, & adaptability throughout the development process.",
    backgroundClass: "bg-3",
  },
  {
    title: "Automation Solutions",
    content:
      "We combine AI automation with Robotic Process Automation to boost operational efficiency, reduce operational costs, & minimize human error, allowing you to focus on strategic initiatives.",
    backgroundClass: "bg-4",
  },
];

export const hireAngularEnagementModelEn = {
  discription: "Choose the engagement model that fits your project needs! Whether you need full-time, part-time, or hourly developers, we offer flexible options to ensure seamless collaboration & maximum efficiency throughout your project.",

  buttonText: "Get Started Now",

  hiringDetails: [
    {
      text: "Hourly Hiring",
      hours: "48",
      timeUnit: "hours",
      icon: "time.svg",
      bgColor: "#FDFDFF",
      durationLabel: "Duration", // Dynamic label
      duration: "8 Hrs/Day",     // Dynamic value
      minimumDaysLabel: "Minimum Days", // Dynamic label
      minimumDays: "30 Days",           // Dynamic value
      billingLabel: "Billing",       // Dynamic label
      billing: "Monthly",            // Dynamic value
      startWorkPhrase: "Start work in "
    },
    {
      text: "Full Time Hiring",
      hours: "72",
      timeUnit: "hours",
      icon: "full-time.svg",
      bgColor: "#FFFEFA",
      durationLabel: "Duration",
      duration: "8 Hrs/Day",
      minimumDaysLabel: "Minimum Days",
      minimumDays: "30 Days",
      billingLabel: "Billing",
      billing: "Monthly",
      startWorkPhrase: "Get started within "
    },
    {
      text: "Part Time Hiring",
      hours: "48",
      timeUnit: "hours",
      icon: "part-time.svg",
      bgColor: "#FDFFFA",
      durationLabel: "Duration",
      duration: "8 Hrs/Day",
      minimumDaysLabel: "Minimum Days",
      minimumDays: "30 Days",
      billingLabel: "Billing",
      billing: "Monthly",
      startWorkPhrase: "Launch in "
    },
  ],

  headingContent: [
    {
      "text": "Our Flexible"
    },
    {
      "text": "Engagement Models"
    },
  ],
};